import LayoutDefault from './default'
import LayoutEmpty from './empty'
export default {
  LayoutDefault,
  LayoutEmpty
}
